import { setValueAndMaxLength } from "../../utils/setValueAndMaxLenght";

const IntakeHistoryInput = (props) => {
  const { title, unit, nextInputRef, inputRef } = props;
  const [value, setValue] = props.state;
  const isDate = props.isDate !== undefined;

  return (
    <div className={`intake-history__custom-item-${isDate ? "date" : "nutrient"}`}>
      <p className={`intake-history__custom-item-${isDate ? "date-title" : "nutrient-name"}`}>{title}</p>
      <input
        className={`intake-history__custom-item-${isDate ? "date" : "nutrient"}-input`}
        placeholder={isDate ? "MM/DD/YYYY" : ""}
        ref={inputRef}
        value={value}
        type={isDate ? "text" : "number"}
        onChange={(e) => {
          if (isDate) {
            if (/^[0-9/]*$/g.test(e.target.value)) {
              setValue(e.target.value);
            }
          } else {
            setValueAndMaxLength(e, setValue, 4);
          }
        }}
        onKeyDown={(e) => {
          if (e.key !== "Enter") return;
          e.preventDefault();
          if (nextInputRef) {
            nextInputRef.current.focus();
          } else {
            inputRef.current.blur();
          }
        }}
        onWheel={() => {
          inputRef.current.blur();
        }}
        maxLength={10}
      />
      {isDate ? "" : <span className="intake-history__custom-item-input-unit">{unit}</span>}
    </div>
  );
};

export default IntakeHistoryInput;
